export enum FeedbackAPIErrorConsts {
  SHOW_SNACKBAR = 'SHOW:SNACKBAR',
  HIDE_SNACKBAR = 'HIDE:SNACKBAR',
}
